import { constantRouterMap } from '@/routes'

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    operator: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
      if (routers.meta) {
        if (routers.meta.permission) {
          state.operator = routers.meta.permission
        }
      }
    }
  },
  actions: {
    // 根据返回得
    GenerateRoutes ({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_ROUTERS', data)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js